var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.197,
    height: 27.194,
    viewBox: "0 0 27.197 27.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.6,27.194a3.719,3.719,0,0,1-3.208-1.848,1.236,1.236,0,0,1,1.069-1.857h4.277a1.237,1.237,0,0,1,1.07,1.857A3.723,3.723,0,0,1,13.6,27.194Zm12.362-6.177H1.236a1.236,1.236,0,0,1,0-2.472,2.476,2.476,0,0,0,2.472-2.473V9.89a9.89,9.89,0,1,1,19.78,0v6.181a2.476,2.476,0,0,0,2.472,2.473A1.185,1.185,0,0,1,27.2,19.78a1.272,1.272,0,0,1-.309.85A1.2,1.2,0,0,1,25.961,21.016ZM13.6,2.472A7.426,7.426,0,0,0,6.181,9.89v6.181a4.948,4.948,0,0,1-.662,2.473H21.677a4.949,4.949,0,0,1-.661-2.473V9.89A7.426,7.426,0,0,0,13.6,2.472Z",
    fill: "#199b8b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/ring-icon.d37325e5b5eabd6daef55f2dca39c16a.svg";
export { ForwardRef as ReactComponent };